import Button from "./Button";
import {swapModal} from "../../libs";

const SingleDeleteModal = (props) => {

    return (
        <div className={"modal fade"} id={props?.modalName ? props.modalName : "deletemodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
             tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
            <div className={"modal-dialog"}>
                <div className={"modal-content"}>
                    <div className={"modal-header bg-pal"}>
                        <h2 className={"modal-title"} id={"staticBackdropLabel"}>{props?.header}</h2>
                        <button type={"button"} className={"btn-close"} id={props?.closeBtn ? props.closeBtn : "confirmClose"}
                                data-bs-dismiss={"modal"} aria-label={"Close"} />
                    </div>
                    <h2 className={"m-3"} style={{textAlign: "center"}} id={props?.modalContentId ? props.modalContentId : "deleteModalContent"}> </h2>
                    <div className={"modal-footer"}>
                        <button type={"button"} className={"btn btn-secondary"} style={{width: "75px"}} id={props?.cancelBtn ? props.cancelBtn : "cancelDeleteBtn"}
                                onClick={() => swapModal(props?.closeBtn ? props.closeBtn : "confirmClose", props?.modal_name ? props.modal_name : "editmodal")}>No</button>
                        <Button type={"button"} class={"btn btn-primary d-none"} style={{width: "75px"}} disabled={true} spinner={true}
                                text={"Deleting"} id={props?.loadBtn ? props.loadBtn : "loadDeleteSubmit"}/>
                        <button type={"button"} className={"btn btn-danger"} style={{width: "75px"}}
                                id={props?.submitBtn ? props.submitBtn : "deleteSubmit"} onClick={() => props?.deletePerform()}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    )

};

export default SingleDeleteModal;